import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { ResultCode } from '../../../../../domain/authentication.model'
import { PhotoType } from '../../../../../enums/enums'
import { NotificationService } from '../../../../../services/notification.service'
import { AppService } from '../../../../../services/prod/app.service'
import { I18nService, LgType } from '../../../../../services/prod/i18n.service'
import { ProducerManagementService } from '../../../../../services/producer-management.service'
import {
  IBeatmakerData,
  UploadDataType,
  UploadImageResultType,
  UploadImageStatusType
} from '../../../../../types/common.type'

@Component({
  selector: 'bmcore-upload-block',
  templateUrl: './bmcore-upload-block.component.html',
  styleUrls: ['./bmcore-upload-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreUploadBlockComponent implements OnInit {
  @Input() uploadItem: UploadDataType
  @Input() uploadItemIndex: number
  @Input() uploadItemLength: number

  lg: LgType
  file: File
  uploadImageResult: UploadImageResultType = {
    status: 'idle',
    message: ''
  }
  beatmakerData: IBeatmakerData
  readonly PhotoType = PhotoType

  constructor(
    private i18nService: I18nService,
    private producerManagementService: ProducerManagementService,
    private appService: AppService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res?.beatmakerId) {
        this.beatmakerData = res
      }
    })
  }

  selectFileHandler(e: Event, photoType: PhotoType) {
    this.changeUploadImageResult('pending', this.lg.colorCustomizer.uploadImagesBlock.loadingMessage)

    const input = e.target as HTMLInputElement
    if (!input.files?.length) {
      return
    }
    this.file = input.files[0]

    this.uploadImage(photoType)
  }

  uploadImage(photoType: PhotoType) {
    this.producerManagementService.upload(this.file, photoType).subscribe(
      res => {
        if (res.resultCode === ResultCode.Success) {
          this.changeUploadImageResult('success', this.lg.colorCustomizer.uploadImagesBlock.successfullyUploaded)
          this.updateImage(photoType, res.data.url)
        } else {
          this.changeUploadImageResult('error', res.messages[0])
        }
      },
      err => this.changeUploadImageResult('error', err.message)
    )
  }

  deleteHandler(photoType: PhotoType) {
    this.producerManagementService.deleteImage(photoType).subscribe(
      res => {
        if (res.resultCode === ResultCode.Success) {
          this.updateImage(photoType, null)
          this.notificationService.handleSuccess(this.lg.colorCustomizer.uploadImagesBlock.successfullyDeleted)
        } else {
          this.notificationService.handleError(res.messages[0])
        }
      },
      err => this.notificationService.handleError(err.message)
    )
  }

  changeUploadImageResult(status: UploadImageStatusType, message: string) {
    this.uploadImageResult = {
      status,
      message
    }
  }

  updateImage(photoType: PhotoType, url: string | null) {
    this.appService.beatMakerDataSubject.next({
      ...this.beatmakerData,
      backgroundImageUrl: photoType === PhotoType.ProPageWallpaperEng ? url : this.beatmakerData.backgroundImageUrl,
      backgroundLogoImageUrl:
        photoType === PhotoType.ProPageWallpaperLogoEng ? url : this.beatmakerData.backgroundLogoImageUrl,
      logoUrl: photoType === PhotoType.ProPageHeaderLogoEng ? url : this.beatmakerData.logoUrl,
      footerLogoUrl: photoType === PhotoType.ProPageFooterLogoEng ? url : this.beatmakerData.footerLogoUrl,
      faviconUrl: photoType === PhotoType.ProPageFaviconEng ? url : this.beatmakerData.faviconUrl
    })
  }
}
